import appStore from 'store';

const store = {
  namespaced: true,
  state: {},
  mutations: {}
};

appStore.registerModule('Inside', store);
